<!--
 * @Author: cryi.liu
 * @Date: 2020-05-28 10:58:53
 * @LastEditTime: 2020-09-23 10:30:44
 * @Description: 试卷基本信息
 -->
<template>
  <div class="examinee-info">
    <table>
      <tbody>
        <tr>
          <td class="category">考试名称：
            <span>{{ paperBaseInfo.examName }}</span>
          </td>
          <td class="category">试卷类别：
            <span>{{ paperBaseInfo.categoryName }}</span>
          </td>
          <td class="category">试卷小类：
            <span>{{ paperBaseInfo.subCategoryName }}</span>
          </td>
        </tr>
        <tr>
          <td class="category">阅卷人：
            <span>{{ paperBaseInfo.markers.join('、') }}</span>
          </td>
          <td class="category">关键词：
            <span>{{ paperBaseInfo.keywords.join('、') }}</span>
          </td>
        </tr>
        <tr>
          <td class="category">考试时间：
            <div v-for="item in paperBaseInfo.examTimes" :key="item.id" class="exam-time">
              <p>开始时间：<span>{{ item.startTime }}</span></p>
              <p>结束时间：<span>{{ item.endTime }}</span></p>
            </div>
          </td>
        </tr>
        <tr v-if="type === 'preview'">
          <td class="category">总人数：
            <span>{{ paperBaseInfo.totalCount }}</span>
          </td>
          <td class="category">考试中：
            <span>{{ paperBaseInfo.startedCount }}</span>
          </td>
          <td class="category">已提交：
            <span>{{ paperBaseInfo.committedCount }}</span>
          </td>
        </tr>
        <tr v-if="type === 'preview'">
          <td class="category">未开考：
            <span>{{ paperBaseInfo.notStartedCount }}</span>
            <span class="a" @click="refreshHandler">刷新</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
  name: 'paperBaseInfo',
  props: {
    type: { type: String, required: true },
    examId: { type: [Number, String], required: true },
    paperBaseInfo: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      token: 'authStore/token',
    }),
  },
  methods: {
    /**
     * 点击刷新处理函数
     */
    refreshHandler() {
      this.requestRefreshPreviewInfo();
    },
    /**
     * 请求刷新考试预览信息
     */
    requestRefreshPreviewInfo() {
      axios.get(`/examcentersite/paper/exam/${this.examId}/statistics`, { headers: { psstoken: this.token } })
        .then((result) => {
          if (result.data.code === '200') {
            const {
              totalCount, startedCount, committedCount, notStartedCount,
            } = result.data.data;

            this.$emit('refresh-count', {
              totalCount, startedCount, committedCount, notStartedCount,
            });
          } else {
            alert(result.data.msg);
          }
        })
        .catch(() => {
          alert('刷新失败');
        });
    },
  },
};
</script>

<style lang="less" scoped>
.examinee-info {
  width: 100%;

  > table {
    width: 100%;

    > tbody {
      width: 100%;

      > tr {
        width: 100%;
        height: 42px;

        > td {
          width: calc(100% / 3);
          vertical-align: middle;
          font-size: 12px;

          &.category {
            font-weight: bold;

            > span {
              font-weight: normal;
            }

            > a {
              margin-right: 16px;

              &:last-of-type {
                margin-right: 0;
              }
            }

            > .a {
              margin-left: 8px;
              color: #0000ee;
              cursor: pointer;
            }

            > .exam-time {
              display: flex;
              padding-top: 12px;

              > p {
                white-space: nowrap;
                margin-right: 20px;

                > span {
                  font-weight: normal;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
